"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputType = exports.CustomInput = void 0;
var react_1 = __importStar(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var fa_1 = require("react-icons/fa");
var react_input_mask_1 = __importDefault(require("react-input-mask"));
var InputType;
(function (InputType) {
    InputType["TEXT"] = "text";
    InputType["NUMBER"] = "number";
    InputType["TEL"] = "tel";
    InputType["PASSWORD"] = "password";
    InputType["EMAIL"] = "email";
    InputType["FILE"] = "file";
})(InputType || (InputType = {}));
exports.InputType = InputType;
var CustomInput = function (_a) {
    var id = _a.id, name = _a.name, label = _a.label, _b = _a.inputType, inputType = _b === void 0 ? InputType.TEXT : _b, value = _a.value, placeholder = _a.placeholder, _c = _a.required, required = _c === void 0 ? false : _c, errorMessage = _a.errorMessage, _d = _a.conditionalErrorVisible, conditionalErrorVisible = _d === void 0 ? false : _d, conditionalErrorMessage = _a.conditionalErrorMessage, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.readOnly, readOnly = _f === void 0 ? false : _f, buttonIcon = _a.buttonIcon, buttonClass = _a.buttonClass, buttonTooltip = _a.buttonTooltip, description = _a.description, tooltip = _a.tooltip, style = _a.style, mainClass = _a.mainClass, className = _a.className, buttonOnClick = _a.buttonOnClick, onChange = _a.onChange, onKeyDown = _a.onKeyDown;
    var _g = (0, react_1.useState)(false), showPassword = _g[0], setShowPassword = _g[1];
    var handleType = inputType === InputType.PASSWORD && showPassword
        ? InputType.TEXT
        : inputType;
    var togglePasswordVisibility = function () {
        setShowPassword(function (prev) { return !prev; });
    };
    var renderInput = function () {
        // If inputType is TEL, use ReactInputMask
        if (inputType === InputType.TEL) {
            return (react_1.default.createElement(react_input_mask_1.default, { mask: "0(999) 999 99 99", value: value, onChange: onChange, onKeyDown: onKeyDown, className: "form-control ".concat(className), style: style, required: required, disabled: disabled, readOnly: readOnly, autoComplete: "new-password" }));
        }
        // Otherwise, return a normal input element
        return (react_1.default.createElement("input", { id: id, name: name, type: handleType, value: value, placeholder: placeholder, onChange: onChange, onKeyDown: onKeyDown, className: "form-control ".concat(className), style: style, required: required, disabled: disabled, readOnly: readOnly, autoComplete: "new-password" }));
    };
    return (react_1.default.createElement("div", { className: mainClass },
        react_1.default.createElement("div", { className: "form-group" },
            react_1.default.createElement("label", { htmlFor: id, className: "form-label" }, label),
            react_1.default.createElement("div", { className: "input-group position-relative" },
                tooltip ? (react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { placement: "bottom", overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: "tooltip-".concat(tooltip) }, tooltip) }, renderInput())) : (renderInput()),
                inputType === InputType.PASSWORD && (react_1.default.createElement("button", { type: "button", onClick: togglePasswordVisibility, className: "btn btn-outline-secondary", title: showPassword ? "Parolayı Gizle" : "Parolayı Göster" }, showPassword ? react_1.default.createElement(fa_1.FaEyeSlash, null) : react_1.default.createElement(fa_1.FaEye, null))),
                buttonIcon && buttonOnClick && (react_1.default.createElement("button", { type: "button", onClick: buttonOnClick, className: buttonClass || "btn btn-outline-secondary", title: buttonTooltip || "" }, buttonIcon)),
                required && (react_1.default.createElement("div", { className: "invalid-feedback text-danger" },
                    react_1.default.createElement("div", { className: "description-icon" },
                        react_1.default.createElement(fa_1.FaExclamationTriangle, null)),
                    react_1.default.createElement("div", { className: "description-text" },
                        react_1.default.createElement("span", null, errorMessage || "Bu alan boş bırakılamaz.")))),
                conditionalErrorVisible && (react_1.default.createElement("div", { className: "conditional-error-message text-warning" },
                    react_1.default.createElement("div", { className: "description-icon" },
                        react_1.default.createElement(fa_1.FaExclamationTriangle, null)),
                    react_1.default.createElement("div", { className: "description-text" },
                        react_1.default.createElement("span", null, conditionalErrorMessage)))),
                description && (react_1.default.createElement("div", { className: "form-description text-secondary" },
                    react_1.default.createElement("div", { className: "description-icon" },
                        react_1.default.createElement(fa_1.FaInfoCircle, null)),
                    react_1.default.createElement("div", { className: "description-text" },
                        react_1.default.createElement("span", null, description))))))));
};
exports.CustomInput = CustomInput;
exports.default = CustomInput;
